module.exports = __webpack_public_path__ + "img/Black-Box-img-tw.38618a05.png";